webpackJsonp([156862697026395],{

/***/ 1680:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CardconnectMerchantSurchargeStatus","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"surchargeEnabled","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Boolean","ofType":null}}},{"args":[],"deprecationReason":null,"description":"The surcharge rate ready to display, for example \"3%\". Null unless the status is ACTIVE.","isDeprecated":false,"name":"surchargeRate","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"surchargeStatus","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"CardconnectSurchargeStatus","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-cardconnect-merchant-surcharge-status-0b4a6dff036ad8fbfbfb.js